import { render, staticRenderFns } from "./ChangeContentCard.vue?vue&type=template&id=12a42860"
import script from "./ChangeContentCard.vue?vue&type=script&lang=js"
export * from "./ChangeContentCard.vue?vue&type=script&lang=js"
import style0 from "./ChangeContentCard.vue?vue&type=style&index=0&id=12a42860&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports